import { req } from 'react-reqq-lite';
import { toastSuccess } from 'react-geek-toast';
import { formatSort, reqLoader, formatNumber } from 'helper';
import * as t from './transformers';
import * as c from './constants';

export const listMerchants = (params) => {
  req.get({
    key: c.MERCHANT_LIST,
    url: '/profile/v1/my/merchants',
    params: formatSort(params),
    transform: (res) => (res.data || []).map(t.transformMerchant),
    onSuccess: (res) => {
      const meta = res?.response?.meta;
      req.set(
        c.MERCHANT_PAGER,
        {
          current_page: meta?.current_page,
          total_pages: meta?.last_page,
          total: meta?.total,
        } || {}
      );
      req.set(c.MERCHANT_FILTER, params);
    },
  });
};

export const selectMerchant = (id) => {
  req.get({
    key: c.MERCHANT_ITEM,
    url: `/profile/v1/my/merchants/${id}`,
    transform: (res) => t.transformMerchant(res.data),
  });
};

export const createMerchant = (onSuccess, onError) => (
  payload,
  onInlineSuccess,
  onInlineError
) => {
  req.post({
    key: c.MERCHANT_ITEM,
    url: '/profile/v1/my/merchants',
    payload,
    onSuccess: (res, state) => {
      toastSuccess('Created!');
      setTimeout(() => {
        listMerchants(state[c.MERCHANT_FILTER]);
      }, 1000);
      const newData = t.transformMerchant(res?.response?.data);
      if (newData?.id) selectMerchant(newData.id);
      if (typeof onSuccess === 'function') onSuccess(newData);
      if (typeof onInlineSuccess === 'function') onInlineSuccess(newData);
    },
    onError: (res) => {
      if (typeof onError === 'function') onError(res);
      if (typeof onInlineError === 'function') onInlineError(res);
    },
  });
};

export const updateMerchant = (id, payload, onSuccess) => {
  req.put({
    key: c.MERCHANT_ITEM,
    url: `/admin/user_mng/v1/user/${id}/profile`,
    payload,
    onSuccess: (res, state) => {
      toastSuccess('Updated!');
      setTimeout(() => {
        listMerchants(state[c.MERCHANT_FILTER]);
      }, 1000);
      selectMerchant(id);
      if (onSuccess) onSuccess(t.transformMerchant(res?.response?.data));
    },
  });
};

export const updateMerchantEmail = (id, payload, onSuccess) => {
  req.put({
    key: c.MERCHANT_ITEM,
    url: `/admin/user_mng/v1/user/${id}`,
    payload,
    onSuccess: (res, state) => {
      toastSuccess('Updated!');
      setTimeout(() => {
        listMerchants(state[c.MERCHANT_FILTER]);
      }, 1000);
      selectMerchant(id);
      if (onSuccess) onSuccess(t.transformMerchant(res?.response?.data));
    },
  });
};

export const removeMerchant = (id, onSuccess) => {
  req.remove({
    key: c.MERCHANT_ITEM,
    url: `/admin/user_mng/v1/user/${id}`,
    onSuccess: (res, state) => {
      toastSuccess('Removed!');
      setTimeout(() => {
        listMerchants(state[c.MERCHANT_FILTER]);
      }, 1000);
      req.set(c.MERCHANT_ITEM, null);
      if (onSuccess) onSuccess();
    },
  });
};

export const listMerchantSettlement = (params) => {
  req.get({
    key: c.MERCHANT_SETTLEMENT_LIST,
    url: '/admin/user_mng/v1/user',
    params: formatSort(params),
    transform: (res) => (res.data || []).map(t.transformMerchantSettlement),
    onSuccess: (res) => {
      req.set(c.MERCHANT_SETTLEMENT_PAGER, res?.response?.meta || {});
      req.set(c.MERCHANT_SETTLEMENT_FILTER, params);
    },
  });
};

export const getCountCard = {
  total_transactions: () => {
    reqLoader(`${c.COUNT_CARD}/total_collections`, true);
    req.get({
      key: `${c.COUNT_CARD}/total_transactions`,
      url: '/admin/game_mng/v1/game',
      per_page: 0,
      onSuccess: (res) => {
        req.set(`${c.COUNT_CARD}/total_transactions`, {
          value: res?.response?.transaction_human,
        });
        req.set(`${c.COUNT_CARD}/total_collections`, {
          value: res?.response?.collection_human,
        });
        reqLoader(`${c.COUNT_CARD}/total_collections`, false);
      },
      onError: () => {
        reqLoader(`${c.COUNT_CARD}/total_collections`, false);
      },
    });
  },
  total_settlement: () => {
    reqLoader(`${c.COUNT_CARD}/total_receivebles`, true);
    req.get({
      key: `${c.COUNT_CARD}/total_settlement`,
      url: '/admin/game_mng/v1/game',
      per_page: 0,
      onSuccess: (res) => {
        req.set(`${c.COUNT_CARD}/total_settlement`, {
          value: res?.response?.transaction_human,
        });
        req.set(`${c.COUNT_CARD}/total_receivebles`, {
          value: res?.response?.collection_human,
        });
        reqLoader(`${c.COUNT_CARD}/total_receivebles`, false);
      },
      onError: () => {
        reqLoader(`${c.COUNT_CARD}/total_receivebles`, false);
      },
    });
  },
};

/* MERCHANT API KEY */
export const listMerchantApiKey = (params) => {
  req.get({
    key: c.MERCHANT_API_KEY_LIST,
    url: '/admin/game_mng/v1/category',
    params: formatSort(params),
    transform: (res) => (res?.data || []).map(t.transformMerchantApiKey),
    onSuccess: (res) => {
      req.set(c.MERCHANT_API_KEY_FILTER, params);
      req.set(c.MERCHANT_API_KEY_PAGER, res?.response?.meta || {});
    },
  });
};

export const createMerchantApiKey = (payload, onSuccess) => {
  req.post({
    key: c.MERCHANT_API_KEY_ITEM,
    url: '/admin/game_mng/v1/category',
    payload,
    onSuccess: (state) => {
      setTimeout(() => {
        listMerchantApiKey(state[c.MERCHANT_API_KEY_FILTER]);
      }, 1000);
      toastSuccess('Added!');
      onSuccess();
    },
  });
};

export const updateMerchantApiKey = (id, payload, onSuccess) => {
  req.put({
    key: c.MERCHANT_API_KEY_ITEM,
    url: `/admin/game_mng/v1/category/${id}`,
    payload,
    onSuccess: (state) => {
      setTimeout(() => {
        listMerchantApiKey(state[c.MERCHANT_API_KEY_FILTER]);
      }, 1000);
      toastSuccess('Updated!');
      onSuccess();
    },
  });
};

export const deleteMerchantApiKey = (id, onSuccess) => {
  req.remove({
    key: c.MERCHANT_API_KEY_ITEM,
    url: `/admin/game_mng/v1/category/${id}`,
    onSuccess: (state) => {
      setTimeout(() => {
        listMerchantApiKey(state[c.MERCHANT_API_KEY_FILTER]);
      }, 1000);
      toastSuccess('Deleted!');
      onSuccess();
    },
  });
};
/* MERCHANT BRANCH END */

/* MERCHANT PROFILE START */
export const getGeneralInfo = (account_id) => {
  req.get({
    key: c.MERCHANT_GENERAL_INFO,
    url: `/profile/v1/my/onboarding/${account_id}/general`,
    transform: (res) => t.transformGeneralInfo(res?.data || {}),
  });
};

export const getBusinessInfo = (account_id, type, checkSavedBusinessInfo) => {
  if (!checkSavedBusinessInfo[type]) {
    req.set(c.MERCHANT_BUSINESS_INFO, t.transformBusinessInfo({}, type));
    return;
  }
  const BUSINESS_TYPE_URL = {
    CORPORATION: `/profile/v1/my/onboarding/${account_id}/corporate`,
    SOLE_PROPRIETORSHIP: `/profile/v1/my/onboarding/${account_id}/sole`,
    INDIVIDUAL: `/profile/v1/my/onboarding/${account_id}/individual`,
    // PARTNERSHIP: `/profile/v1/my/onboarding/${account_id}/partnership`,
    GOVERNMENT: `/profile/v1/my/onboarding/${account_id}/government`,
  };
  req.get({
    key: c.MERCHANT_BUSINESS_INFO,
    url: BUSINESS_TYPE_URL[type],
    transform: (res) => t.transformBusinessInfo(res?.data || {}, type),
  });
};
/* MERCHANT PROFILE START */

/* MERCHANT CATEGORY & CHANNEL ATTACHMENT START */
export const listMerchantAttachedCategories = (id) => {
  req.get({
    key: c.LIST_PAYMENT_CATEGORIES,
    url: `/core_merchant_channel/v1/mng/merchants/${id}/payment_categories`,
    transform: (res) =>
      (res.data || []).map(t.transformAttachedPaymentCategory),
  });
};

export const listPaymentCategoryChannels = (merchantId, paymentCategoryId) => {
  req.get({
    key: c.LIST_PAYMENT_CATEGORY_CHANNELS(paymentCategoryId),
    url: `/core_merchant_channel/v1/mng/merchants/${merchantId}/payment_categories/${paymentCategoryId}/payment_channels`,
    transform: (res) => (res.data || []).map(t.transformAttachedPaymentChannel),
  });
};

export const listSelectChannels = (params) => {
  req.get({
    key: c.LIST_SELECT_PAYMENT_CHANNELS,
    url: '/core_channel/payment/v1/mng/payment_channels',
    params,
    transform: (res) => (res.data || []).map(t.transformChannelOptions),
  });
};

export const activateMerchantPaymentCategory = (
  merchantId,
  categoryId,
  successCallback,
  errorCallback
) => {
  req.put({
    key: c.TOGGLE_CATEGORY_STATUS,
    url: `/core_merchant_channel/v1/mng/merchants/${merchantId}/payment_categories/${categoryId}/activate`,
    onSuccess: () => {
      if (typeof successCallback === 'function') successCallback();
    },
    onError: () => {
      if (typeof errorCallback === 'function') errorCallback();
    },
  });
};

export const deactivateMerchantPaymentCategory = (
  merchantId,
  categoryId,
  successCallback,
  errorCallback
) => {
  req.put({
    key: c.TOGGLE_CHANNEL_STATUS,
    url: `/core_merchant_channel/v1/mng/merchants/${merchantId}/payment_categories/${categoryId}/deactivate`,
    onSuccess: () => {
      if (typeof successCallback === 'function') successCallback();
    },
    onError: () => {
      if (typeof errorCallback === 'function') errorCallback();
    },
  });
};

export const toggleAttachedChannelStatus = (
  merchantId,
  categoryId,
  channelId,
  payload,
  successCallback,
  errorCallback
) => {
  req.put({
    key: c.TOGGLE_CHANNEL_STATUS,
    url: `/core_merchant_channel/v1/mng/merchants/${merchantId}/payment_categories/${categoryId}/payment_channels/${channelId}/status`,
    payload,
    onSuccess: () => {
      if (typeof successCallback === 'function') successCallback();
    },
    onError: () => {
      if (typeof errorCallback === 'function') errorCallback();
    },
  });
};
/* MERCHANT CATEGORY & CHANNEL ATTACHMENT END */

/* BILLER AND ORGANIZATION SETTLEMENT */
export const billerSettlementList = (id, params) => {
  req.get({
    key: `${c.MERCHANT_SETTLEMENT_LIST}/biller`,
    params: {
      sort: 'desc',
      ...params,
    },
    url: `/wallet/v1/biller_mgmt/billers/${id}/settlement`,
    transform: (res) => ({
      list: (res?.data || []).map(t.transformBillerSettlementList),
      accumulated_amount: formatNumber(res?.accumulated_amount, 2),
      total_pending_dispute_amount: formatNumber(
        res?.total_pending_dispute_amount,
        2
      ),
      pending_amount: formatNumber(res?.pending_amount, 2),
    }),
    onSuccess: (res) => {
      req.set(`${c.MERCHANT_SETTLEMENT_PAGER}/biller`, {
        current_page: res?.response?.meta?.current_page || 0,
        total_pages: res?.response?.meta?.last_page || 0,
        total: res?.response?.meta?.total || 0,
      });
    },
  });
};

export const orgSettlementList = (id, params) => {
  req.get({
    key: `${c.MERCHANT_ORG_SETTLEMENT_LIST}/org`,
    params: {
      sort: 'desc',
      ...params,
    },
    url: `/wallet/v1/biller_mgmt/organizations/${id}/settlement`,
    transform: (res) => ({
      list: (res?.data || []).map(t.transformBillerSettlementList),
      accumulated_amount: formatNumber(res?.accumulated_amount, 2),
      total_pending_dispute_amount: formatNumber(
        res?.total_pending_dispute_amount,
        2
      ),
      pending_amount: formatNumber(res?.pending_amount, 2),
    }),
    onSuccess: (res) => {
      req.set(`${c.MERCHANT_ORG_SETTLEMENT_PAGER}/org`, {
        current_page: res?.response?.meta?.current_page || 0,
        total_pages: res?.response?.meta?.last_page || 0,
        total: res?.response?.meta?.total || 0,
      });
    },
  });
};

export const selectedBillerSettlement = (merchantId, settlementId) => {
  req.get({
    key: `${c.MERCHANT_SETTLEMENT_GET}/biller`,
    url: `/wallet/v1/biller_mgmt/billers/${merchantId}/settlement/${settlementId}`,
    transform: ({ data }) => t.transformSelectedBillerSettlement(data),
  });
};

export const selectedOrgSettlement = (merchantId, settlementId) => {
  req.get({
    key: `${c.MERCHANT_SETTLEMENT_GET}/biller`,
    url: `/wallet/v1/biller_mgmt/organizations/${merchantId}/settlement/${settlementId}`,
    transform: ({ data }) => t.transformSelectedBillerSettlement(data),
  });
};

export const addBillerSettlement = (id, payload, callback) => {
  req.post({
    key: c.MERCHANT_SETTLEMENT_ADD,
    payload,
    url: `/wallet/v1/biller_mgmt/billers/${id}/settlement`,
    onSuccess: () => {
      if (typeof callback === 'function') callback();
    },
  });
};
/* BILLER AND ORGANIZATION SETTLEMENT END */
